<template>
  <div class="Policy" @keydown.enter="query()">
    <div class="white_box">
      <div class="filter">
        <!-- 搜索框 -->
        <el-input
          class="custom-ts"
          size="medium"
          placeholder="请输入标题关键字"
          v-model="input_title"
          clearable
        ></el-input>
        <el-input
          class="custom-cs"
          size="medium"
          placeholder="请输入查询城市"
          v-model="input_city"
          clearable
        ></el-input>
        <el-date-picker
          class="custom-zone"
          v-model="during"
          type="daterange"
          align="center"
          unlink-panels
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="zoneChange"
        ></el-date-picker>
        <!-- 查询&重置按钮 -->
        <button-a color="#f26828" class="query" @click.native="query()">查询</button-a>
        <button-a color="#08a752" @click.native="reset()">重置</button-a>
      </div>

      <div class="result">
        <div class="list">
          <el-scrollbar class="scroll" style="height:100%" v-infinite-scroll="loadMore">
            <div
              v-for="(item, index) in list"
              :key="item.noticeId || index"
              class="item row pointer"
              :class="{active: item.noticeId === currentID}"
              @click="getItem(item.noticeId)"
            >
              <p class="city font_14_blue">{{item.city}}</p>
              <p class="item_title font_14_black">{{item.noticeName}}</p>
              <p class="time font_14_gray">{{date(item.receiveTime)}}</p>
              <div :class="{show: item.noticeId === currentID}" class="fold_btn">
                <img class="fold_icon" src="@/assets/icons/down002-E03A@2x.png" alt />
              </div>
            </div>
            <div v-show="!list || null_list" class="noData">
              <img class="nodata_img" src="@/assets/icons/nodata.png" alt="">
              <p class="font_14_gray">暂无政策公告</p>
            </div>
          </el-scrollbar>
        </div>
        <div class="detail">
          <div class="page row">
            <div class="prev row font_14_lightgray" @click="getItem(current.prev.noticeId)">
              <i class="el-icon-back"></i>
              <p class="prev_title">{{current.prev.noticeName}}</p>
            </div>
            <div class="next row font_14_lightgray" @click="getItem(current.next.noticeId)">
              <p class="next_title">{{current.next.noticeName}}</p>
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div v-show="!null_list" class="content">
            <div class="scroll-box">
              <el-scrollbar class="scroll" style="height:100%" v-infinite-scroll="loadMore">
                <h3 class="font_20_black title">{{current.noticeName}}</h3>
                <p class="font_14_darkgray release_time">发布时间： {{date(current.announceTime)}}</p>
                <p class="font_14_black text">{{current.noticeContent}}</p>
                <el-divider></el-divider>
                <p class="font_14_darkgray city">城市：{{current.city}}</p>
                <p class="font_14_darkgray effect_time">生效时间：{{date(current.effectTime)}}</p>
                <p class="font_14_darkgray link">
                  <span>公告链接：</span>
                  <a @click="newtab(current.policyPath)" class="font_14_blue">{{current.policyPath}}</a>
                </p>
                <el-divider></el-divider>
                <!-- <a
                  class="pdf row"
                  :href="current.attachmentPath"
                  :download="current.noticeName + '.pdf'"
                >
                  <img class="pdf_icon" src="@/assets/icons/pdf@2x.png" alt />
                  <p
                    class="font_14_blue"
                  >{{current.attachmentPath ? current.attachmentPath.split("_").pop() : ""}}</p>
                </a> -->
              </el-scrollbar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { Get } from "@/js/http.js";
import { dateConvert } from "@/js/tool.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      needScroll: Boolean(this.$route.params.noticeID),
      input_title: "", // 搜索标题
      input_city: "", // 搜索城市
      during: null, // 时间区间，array或null，包含开始时间和结束时间的Date对象
      pickerOptions: {
        // 快捷时间区间选项
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      list: [], // 文件列表
      total: 0, // 列表总长度
      page: 1, // 当前页码
      size: 20, // 每页条数
      gettingMore: false,
      currentID: "" // 当前选择文件
    };
  },
  watch: {},
  computed: {
    // 跳过条数
    SkipCount() {
      return (this.page - 1) * this.size;
    },
    // 当前文件详情，并包含前后文件的标题和id
    current() {
      let list = this.list;
      let index = list.findIndex(item => {
        return item.noticeId === this.currentID;
      });
      let none = { noticeName: "无", noticeId: "" };
      let prev = list[index - 1] ? list[index - 1] : none;
      let next = list[index + 1] ? list[index + 1] : none;
      return {
        prev,
        next,
        ...list[index]
      };
    },
    // 列表是否为空
    null_list() {
      return this.list.length === 0;
    },
    // 开始时间
    ReceiveTimeStart() {
      if (this.during) {
        return dateConvert(this.during[0]);
      } else {
        return "";
      }
    },
    // 结束时间
    ReceiveTimeEnd() {
      if (this.during) {
        return dateConvert(this.during[1]);
      } else {
        return "";
      }
    }
  },
  methods: {
    // 时间区间变更
    zoneChange(v) {
      if (v) {
        this.during = [dateConvert(v[0]), dateConvert(v[1])]; // 不选时v为null
      } else {
        this.during = ["", ""];
      }
    },
    // 获取列表数据
    getList() {
      if (this.gettingMore || this.SkipCount > this.total) {
        return false;
      }
      this.gettingMore = true;
      Get("api/v1/policy-notices", {
        NoticeName: this.input_title, // 标题搜索
        City: this.input_city, // 城市
        ReceiveTimeStart: this.ReceiveTimeStart, // 生效时间开始
        ReceiveTimeEnd: this.ReceiveTimeEnd, // 生效时间开始
        // Sorting: "", // 排序
        MaxResultCount: this.size, // 最大返回条数
        SkipCount: this.SkipCount // 忽略条数
      })
        .then(({ data }) => {
          if (this.page === 1) {
            this.list = data.items;
          } else {
            this.list = this.list.concat(data.items);
          }
          this.total = data.totalCount;
          this.gettingMore = false;
        })
        .then(() => {
          if (this.needScroll && this.list.length > 0) {
            this.currentID = this.$route.params.noticeId || this.$route.params.noticeID;
            this.getItem(this.currentID);
            this.scrollToItem();
            this.needScroll = false; // 只自动滚动一次
          } else if (this.page === 1 && this.list.length > 0) {
            this.currentID = this.list[0].noticeId;
            this.getItem(this.currentID); // 第一页时自动获取第一项详情
          }
          // else if (this.list.length <= 0) {

          // }
          this.page++;
        });
    },
    // 获取详情数据
    getItem(id) {
      if (!id) {
        return;
      }
      this.currentID = id;

      Get("api/v1/policy-notices", {
        noticeId: id // 客户ID
      }).then(() => {
        // this.total = res.data.data.totalCount;
        // this.tableData = res.data.data.items;
      });
    },
    // 滚动到选择项
    scrollToItem() {
      const activeItem = $(".item.active");
      if (activeItem.length > 0) {
        $(".list .el-scrollbar__wrap").scrollTop(
          activeItem.position().top
        );
      }
    },
    // 转换
    date(dateStr) {
      return dateConvert(dateStr);
    },
    // 查询
    query() {
      this.page = 1; // 页码归位
      this.getList();
    },
    // 重置
    reset() {
      this.input_city = "";
      this.input_title = "";
      this.during = null;
      this.query();
    },
    // 列表触底加载更多
    loadMore() {
      this.getList();
    },
    newtab(url) {
      window.open(url);
    }
  },
  created() {},
  mounted() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.Policy {
  // position: absolute;
  // top: 60px;
  // bottom: 0;
  flex: 1;
  align-self: stretch;
  width: 100%;
  height: 845px;
  padding: 120px 32px 0;
  overflow: hidden;
  .white_box {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .filter {
    display: flex;
    align-items: center;
    padding: 22px 48px;
    height: 80px;
    min-height: 80px;
    border-bottom: 1px solid #efeff3;
    position: fixed;
    top: 70px;
    left: 11.6vw;
    right: 0;
    z-index: 100;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    max-width: calc(100% - 11.6vw);
    border: 1px solid #e5e5e5;
    border-radius: 6px;
  }
  // .el-select {
  // }
  .result {
    flex: 1;
    display: flex;
  }
  .list {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #f7f7f9;
    border-right: 2px solid #e5e5e5;
    position: relative;
    overflow: hidden;
    .scroll {
      // flex: 1;
      height: 100%;
      // height: 400px;
      position: absolute;
      overflow-x: hidden;
      overflow-y: auto;
      left: 0;
      right: 0px;
    }
    .item {
      padding-left: 48px;
      padding-right: 40px;
      height: 88px;
      border-bottom: 1px solid transparent;
      &.active {
        background-color: #fff;
        padding-left: 46px;
        border-left: 2px solid #f26828;
        border-bottom: 1px solid #e5e5e5;
        box-shadow: 0px 4px 8px 0px rgba(100, 100, 100, 0.1);
      }
      .city {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        padding: 0 12px;
        height: 24px;
        background-color: #eff2fe;
        border-radius: 8px;
      }
      .item_title {
        flex: 1;
      }
      .time {
        margin-right: 8%;
      }
      .fold_btn {
        transform: rotate(-90deg);
        opacity: 0;
        &.show {
          opacity: 1;
        }
        img {
          display: block;
          width: 24px;
          height: 24px;
        }
      }
    }
  }
  .detail {
    display: flex;
    flex-direction: column;
    width: 60%;
    .page {
      justify-content: space-between;
      padding: 0 104px;
      height: 88px;
      border-bottom: 1px solid #e5e5e5;
      .prev,
      .next {
        cursor: pointer;
      }
    }
    .content {
      flex: 1;
      padding: 60px 106px 0;
      line-height: 1;
      .scroll-box {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      .scroll {
        // position: absolute;
        // flex: 1;
        height: 100%;
        // height: 400px;
        position: absolute;
        overflow-x: hidden;
        overflow-y: auto;
        left: 0;
        right: 0px;
      }
      .title {
        margin: 0;
        padding: 0;
        margin-bottom: 20px;
      }
      .release_time {
        margin-bottom: 40px;
      }
      .text {
        line-height: 28px;
      }
      .el-divider {
        margin: 50px 0;
      }
      .city {
        margin-bottom: 18px;
      }
      .effect_time {
        margin-bottom: 18px;
      }
      .link {
        display: flex;
        span {
          // overflow: hidden;
          white-space: nowrap;
        }
        a {
          word-break: break-all;
          // white-space: wrap;
          // word-wrap: wrap;
          text-decoration: none;
          cursor: pointer;
        }
      }
      .pdf {
        margin-bottom: 50px;
        cursor: pointer;
      }
      .pdf_icon {
        margin-right: 15px;
      }
    }
  }
}
.custom-zone {
  margin-right: 80px;
}
.query {
  margin-right: 32px;
}
.el-scrollbar {
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
.prev_title {
  margin-left: 8px;
}
.next_title {
  margin-right: 8px;
}
.noData {
  margin-top: 200px;
}
</style>